const styles = {
    commonInput: {
        '& .input-wrapper:not(.has-auto-width) .clear-input-button': {
            right: '34px',
            top: '50%',
            transform: 'translateY(-50%)'
        }
    },
    menuContainer: {
        position: 'absolute',
        top: 'calc(100% + 2px)',
        left: 0,
        width: '100%'
    },
    dropdown: {
        width: 'max-content',
        minWidth: '100%',
        maxWidth: 'min(360px, calc(100vw - 32px))',
        maxHeight: 'none',
        overflowY: 'hidden'
    },
    dropdownItem: {
        height: 'auto',
        minHeight: '44px',
        boxSizing: 'border-box',
        padding: '12px 18px',
        gap: '10px'
    },
    optionText: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere'
    },
    dropdownList: {
        maxHeight: '260px',
        overflowY: 'auto',
        position: 'relative'
    }
}

export default styles
